import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Layout route only. The 30-day playbook lives in playbook.index.tsx and the
 * gated guide in playbook.ai-citation-guide.tsx.
 */
export const Route = createFileRoute("/playbook")({
  component: () => <Outlet />,
});
